import {
  borderRadius,
  breakpoints,
  Button,
  DropdownMenu,
  Input,
  typographyV2,
} from '@toggle/design-system';
import styled, { css } from 'styled-components';

import type { WebSearchDropdownVariant } from './WebSearchDropdown';

interface StyledDropdownMenuProps {
  $variant?: WebSearchDropdownVariant;
}

export const StyledDropdownMenu = styled(DropdownMenu)<StyledDropdownMenuProps>`
  ${DropdownMenu.Styled.DropdownContent} {
    gap: 0;
  }

  @media ${breakpoints['max-xs']} {
    width: 250px;
    min-width: 250px;
  }

  ${({ $variant }) =>
    $variant === 'select' &&
    css`
      width: 100%;

      ${DropdownMenu.Styled.DropdownContent} {
        width: 100%;
        max-width: 100%;
      }
    `}
`;

export const SelectWrapper = styled.div`
  width: 100%;

  ${Input.Styles?.InputElement} {
    cursor: pointer;
    width: 100%;
    min-height: 40px;
    height: 40px;
    box-sizing: border-box;
  }

  ${Input.Styles?.InputWrapper} {
    ${borderRadius.r2};
    min-height: 40px;
    height: 40px;
    box-sizing: border-box;
  }
`;

export const OptionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Label = styled.span`
  ${typographyV2.bodySm};
`;

export const StyledButton = styled(Button)`
  margin-top: 1px;
`;

export const StyledXsButton = styled(Button)`
  margin-left: 36px;
  width: 209px;
`;
